import { useState } from 'react';
import setObjectKetValue from 'helpers/setObjectKetValue';

const useFormInputState = (initialState) => {
  const [state, setState] = useState(initialState);

  const setKeyValue = (key, value) =>
    setState((c) => setObjectKetValue({ ...c }, key, value));

  const onChange = ({ target }) => {
    const { value, checked, name } = target;
    const finalValue =
      target.getAttribute?.('type') === 'checkbox' ? checked : value;

    setKeyValue(name, finalValue);
  };

  return [state, onChange, setKeyValue];
};

export default useFormInputState;
